
import { TRole } from "../model/IRole";

// --
export type TPageUrl =
| '/oauth/signIn'
| '/users'
| '/users/new'
| '/dev'
| '/account'
| '/roles'
| '/vendors'
| '/vendors/new'

;

type IAccess<T extends string | number | symbol> = {
  [key in T]: (Partial<TRole | '*'>)[];
};

// --
// -- Access map
// --
export const pagesAccess: IAccess<TPageUrl> = {
  '/oauth/signIn':  ['*'], 
  '/users'  :       ['ROLE_ADMIN'],
  '/users/new' :    ['ROLE_ADMIN'],
  '/dev' :          ['ROLE_ADMIN'],  
  '/roles':         ['ROLE_ADMIN'],
  '/vendors':       ['ROLE_ADMIN'],
  '/vendors/new':   ['ROLE_ADMIN'],
  '/account':       ['ROLE_AGENT', 'ROLE_VENDOR', 'ROLE_ADMIN'],
};

export const settingAccess = {
  'add-user':     ['ROLE_ADMIN'],
  'edit-user':    ['ROLE_ADMIN'],
  'delete-user':  ['ROLE_ADMIN'],
  'edit-enable':  ['ROLE_ADMIN'],
  'add_role':     ['ROLE_ADMIN'],
  'delete-role':  ['ROLE_ADMIN'],
  'edit-role':    ['ROLE_ADMIN'],
  'add-vendor':   ['ROLE_ADMIN'],
  'edit-vendor':  ['ROLE_ADMIN'],
  'delete-vendor':['ROLE_ADMIN'],
};

export type TSettingNames = keyof typeof settingAccess;
